import { ReactNode, useEffect, useState } from 'react';
import {
	Container,
	ContainerButton,
	ContainerIcon,
	Content,
	TabButton,
	TabNav,
} from './Tabs.styles';

type ItemProps = {
	id: number;
	name: any;
	icon?: ReactNode;
	component?: ReactNode | string;
};

export type positionProps = 'right' | 'left' | 'top' | 'bottom' | 'all';

export interface TabsProps {
	id?: string;
	className?: string;
	tabs?: ItemProps[];
	width?: string | undefined;
	onChange?: (id: number) => void;
	activeTab?: number;
	overflow?: string | undefined;
	position?: positionProps;
	children?: ReactNode;
	contentHeight?: string;
	contentPadding?: string;
}

export const Tabs = ({
	id,
	width,
	overflow,
	children,
	tabs,
	className,
	activeTab,
	position = 'left',
	contentHeight = '100%',
	onChange,
	contentPadding,
}: TabsProps): JSX.Element => {
	const [tabId, setTabId] = useState<number>(0);

	useEffect(() => {
		if (onChange && activeTab !== tabId) {
			onChange(tabId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tabId]);

	useEffect(() => {
		if (activeTab !== undefined) {
			setTabId(activeTab);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Container id={id} className={className}>
			<TabNav
				id="ds-tab-nav"
				className="ds-content-container-nav"
				position={position}
				$columns={tabs?.length ?? 1}
			>
				{tabs?.map((item) => (
					<li key={item.id}>
						<ContainerButton
							active={activeTab === item.id}
							hasIcon={!!item.icon}
						>
							<ContainerIcon>{item.icon}</ContainerIcon>
							<TabButton
								onClick={() => setTabId(item.id)}
								id={`ds-tab-item-${item.id}`}
								hasIcon={!!item.icon}
							>
								{item.name}
							</TabButton>
						</ContainerButton>
					</li>
				))}
			</TabNav>
			{children ? (
				children
			) : (
				<Content
					className="ds-content-container-tabs"
					contentHeight={contentHeight}
					width={width}
					overflow={overflow}
					contentPadding={contentPadding}
				>
					{tabs?.[tabId]?.component || null}
				</Content>
			)}
		</Container>
	);
};
